import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=c373b480"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports